<template lang="pug">
  div
    el-row.margin-top
      el-col
        div(v-if="localizacoes && localizacoes.length")
          app-resumo-mapa(
            :key="mapaKey"
            :idMapa="'appResumo' + cadastroGleba.nome"
            :localizacoes="localizacoes",
            :isVisualizarCadastro="true"
            :height="55"
          )
        div(v-else)
          span Não foi informado nenhum dado durante o cadastro.
</template>

<script>
import AppResumoMapa from '@/components/resumo/AppResumoMapa'
export default {

  components: {
    AppResumoMapa
  },

  props: {
    cadastroGleba: {
      required: true
    },
    isVisivel: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      mapaKey: 1,
      localizacoes: []
    }
  },
  computed: {

  },
  async created () {
  },
  methods: {
  },
  watch: {
    'cadastroGleba.localizacao': {
      async handler (newValue) {
        if (newValue) {
          this.localizacoes = [JSON.parse(newValue)]
        }
      },
      immediate: true
    },
    isVisivel: {
      async handler (newValue) {
        if (newValue) {
          this.mapaKey++
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.margin-top {
  margin-top: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/screens/bancoDados/components/InformacoesGeo.vue